import {
    Flex, useColorModeValue, Button, Heading, Image, Stack, Text, useBreakpointValue, Box, SimpleGrid, Icon, VStack, CardBody, Card,
    Container, HStack, Accordion, AccordionButton, AccordionItem, AccordionPanel
} from "@chakra-ui/react"
import ComputerPic_640 from "../../images/quote_pdf_full_640.webp"
import ComputerPic_455 from "../../images/quote_pdf_full_455.webp"
import ComputerPic_341 from "../../images/quote_pdf_full_341.webp"

import ProductTable_768 from "../../images/product_table_cropped_768.webp"
import ProductTable_1025 from "../../images/product_table_cropped_1025.webp"
import ProductTable_1440 from "../../images/product_table_cropped_1440.webp"

import { FcCollaboration, FcServices, FcShop } from "react-icons/fc"
import { useNavigate } from "react-router-dom"
import { CheckIcon, ChevronDownIcon } from "@chakra-ui/icons"
import Footer from "../../components/Footer"
import { useTranslation } from "react-i18next";

const Feature = ({ title, text, icon }) => {
    return (
        <Stack >
            <Flex
                align={"center"}
                justify={"center"}
                color={"white"}
                rounded={"full"}
                bg={"gray.100"}
                m={1}
            >
                <Card p={3}>
                    <CardBody>
                        {icon}
                        <Text fontWeight={600}>{title}</Text>
                        <Text color={"gray.600"}>{text}</Text>
                    </CardBody>
                </Card>
            </Flex>
        </Stack>
    )
}



export default function HomeSO() {
    const navigate = useNavigate()
    const { t } = useTranslation('signedOut')

    const features = [
        {
            id: 1,
            title: t('store_information'),
            text: t('store_information_note')
        },
        {
            id: 2,
            title: t('merge_terms'),
            text: t('merge_terms_note')
        },
        {
            id: 3,
            title: t('apply_discount_markup'),
            text: t('apply_discount_markup_note')
        },
        {
            id: 4,
            title: t('convert_to_invoice'),
            text: t('convert_to_invoice_note')
        },
        {
            id: 5,
            title: t('upload_resources'),
            text: t('upload_resources_note')
        },
        {
            id: 6,
            title: t('style_documents'),
            text: t('style_documents_note')
        },
    ]

    return (
        <>
            <Flex
                minH={"fit-content"}
                justify={"center"}
                bg={useColorModeValue("gray.50", "gray.800")}
                pt={"2rem"}
            >
                <VStack>
                    <Stack minH={"30vh"} direction={{ base: "column", md: "row" }}>
                        <Flex p={8} flex={3} align={"center"} justify={"center"}>
                            <Stack spacing={6} w={"full"} maxW={"lg"}>
                                <Heading fontSize={{ base: "3xl", md: "4xl", lg: "5xl" }}>
                                    <Text
                                        as={"span"}
                                        position={"relative"}
                                        _after={{
                                            content: "''",
                                            width: "full",
                                            height: useBreakpointValue({ base: "20%", md: "30%" }),
                                            position: "absolute",
                                            bottom: 1,
                                            left: 0,
                                            bg: "cyan.700",
                                            zIndex: -1
                                        }}
                                    >
                                        {t('generate')}
                                    </Text>
                                    <br />{" "}
                                    <Text color={"cyan.700"} as={"span"}>
                                        {t('business_documents')}
                                    </Text>{" "}
                                </Heading>
                                <Text fontSize={{ base: "md", lg: "lg" }} color={"gray.500"}>
                                    {t('generate_note')}
                                </Text>
                                <Stack direction={{ base: "column", md: "row" }} spacing={4}>
                                    <Button
                                        rounded={"full"}
                                        bg={"cyan.700"}
                                        color={"white"}
                                        _hover={{
                                            bg: "blue.500"
                                        }}
                                        onClick={() => { navigate("/signup/company") }}
                                    >
                                        {t('get_started')}
                                    </Button>
                                    <Button rounded={"full"} onClick={() => { navigate("/howitworks") }}>{t('how_it_works')}</Button>
                                </Stack>
                            </Stack>
                        </Flex>
                        <Flex flex={2}>
                            {/* <Image
                                alt={"Login Image"}
                                objectFit={"contain"}
                                src={ComputerPic}
                                //srcSet={`${ComputerPic_213} 213w, ${ComputerPic_256} 256w, ${ComputerPic_341} 341w, ${ComputerPic_455} 455w, ${ComputerPic_533} 533w, ${ComputerPic_640} 640w`}
                                //sizes="(max-width: 600px) 100vw, (max-width: 1200px) 50vw, 800px"
                            /> */}
                            {/* <LazyLoadImage 
                                src={ComputerPic}
                            /> */}
                            <Image
                                src={ComputerPic_455}
                                srcSet={`${ComputerPic_341} 341w, ${ComputerPic_455} 455w, ${ComputerPic_640} 640w`}
                                sizes="
                                    (max-width: 600px) 341px,
                                    (max-width: 1200px) 455px,
                                    640px
                                "
                                alt="Description of the image"
                                />
                        </Flex>
                    </Stack>
                    <Box p={4} mx={['2.5rem', '5rem', '2.5rem', '10rem', '15rem']} my={'5rem'}>
                        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={10}>
                            <Feature
                                icon={<Icon as={FcCollaboration} w={10} h={10} />}
                                title={t('user_friendly')}
                                text={t('user_friendly_note')}
                            />
                            <Feature
                                icon={<Icon as={FcServices} w={10} h={10} />}
                                title={t('simple_setup')}
                                text={t('simple_setup_note')}
                            />
                            <Feature
                                icon={<Icon as={FcShop} w={10} h={10} />}
                                title={t('small_business')}
                                text={t('small_business_note')}
                            />
                        </SimpleGrid>
                    </Box>
                    <Stack minH={"30vh"} direction={{ base: "column", md: "row" }}>
                        <Flex flex={3} >
                            {/* <Image
                                alt={"Login Image"}
                                objectFit={"contain"}
                                src={ContactPic}
                            /> */}
                            {/* <LazyLoadImage 
                                src={ContactPic}
                            /> */}
                            <Image
                                src={ProductTable_768}
                                srcSet={`${ProductTable_768} 768w, ${ProductTable_1025} 1025w, ${ProductTable_1440} 1440w`}
                                sizes="
                                    (max-width: 600px) 768px,
                                    (max-width: 1200px) 1025px,
                                    1440px
                                "
                                alt="Description of the image"
                            />
                        </Flex>
                        <Flex p={8} flex={2} align={"center"} justify={"center"}>
                            <Stack spacing={6} w={"full"} maxW={"lg"}>
                                <Heading fontSize={{ base: "3xl", md: "4xl", lg: "5xl" }}>
                                    <Text
                                        as={"span"}
                                        position={"relative"}
                                        _after={{
                                            content: "''",
                                            width: "full",
                                            height: useBreakpointValue({ base: "20%", md: "30%" }),
                                            position: "absolute",
                                            bottom: 1,
                                            left: 0,
                                            bg: "cyan.700",
                                            zIndex: -1
                                        }}
                                    >
                                        {t('consolidate')}
                                    </Text>
                                    <br />{" "}
                                    <Text color={"cyan.700"} as={"span"}>
                                        {t('your_information')}
                                    </Text>{" "}
                                </Heading>
                                <Text fontSize={{ base: "md", lg: "lg" }} color={"gray.500"}>
                                    {t('consolidate_note')}
                                </Text>
                            </Stack>
                        </Flex>
                    </Stack>
                    <Box p={4} my={'5rem'}>
                        <Stack spacing={4} as={Container} maxW={"3xl"} textAlign={"center"}>
                            <Heading fontSize={"3xl"}>{t('what_we_offer')}</Heading>
                            <Text color={"gray.600"} fontSize={"xl"}>
                                {t('what_we_offer_note')}
                            </Text>
                        </Stack>

                        <Container maxW={"6xl"} mt={14}>
                            <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={10}>
                                {features.map(feature => (
                                    <HStack key={feature.id} align={"top"}>
                                        <Box color={"green.400"} px={2}>
                                            <Icon as={CheckIcon} />
                                        </Box>
                                        <VStack align={"start"}>
                                            <Text fontWeight={600}>{feature.title}</Text>
                                            <Text color={"gray.600"}>{feature.text}</Text>
                                        </VStack>
                                    </HStack>
                                ))}
                            </SimpleGrid>
                        </Container>
                    </Box>
                    <Heading fontSize={"3xl"} mb={"3rem"}>{t('faq')}</Heading>
                    <Accordion width="60%" rounded="lg" mb="5rem">
                        <AccordionItem>
                            <AccordionButton
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                p={4}
                                _expanded={{ bg: 'cyan.700', color: 'white' }}
                            >
                                <Text fontSize="md">{t('what_is_rapidtoolz')}</Text>
                                <ChevronDownIcon fontSize="24px" />
                            </AccordionButton>
                            <AccordionPanel pb={4}>
                                <Text color="gray.600">
                                    {t('what_is_rapidtoolz_note')}
                                </Text>
                            </AccordionPanel>
                        </AccordionItem>
                        <AccordionItem>
                            <AccordionButton
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                p={4}
                                _expanded={{ bg: 'blue.500', color: 'white' }}
                            >
                                <Text fontSize="md">{t('do_i_need_demo')}</Text>
                                <ChevronDownIcon fontSize="24px" />
                            </AccordionButton>
                            <AccordionPanel pb={4}>
                                <Text color="gray.600">
                                    {t('do_i_need_demo_note')}
                                </Text>
                            </AccordionPanel>
                        </AccordionItem>
                        <AccordionItem>
                            <AccordionButton
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                p={4}
                                _expanded={{ bg: 'blue.700', color: 'white' }}
                            >
                                <Text fontSize="md">{t('how_create_custom_quote')}</Text>
                                <ChevronDownIcon fontSize="24px" />
                            </AccordionButton>
                            <AccordionPanel pb={4}>
                                <Text color="gray.600">
                                    {t('how_create_custom_quote_note')}
                                </Text>
                            </AccordionPanel>
                        </AccordionItem>
                    </Accordion>
                </VStack>
            </Flex>
            <Footer />
        </>
    )
}